import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { removeActiveModal } from '../../redux/layout/layoutState';
import { useDispatch } from "react-redux";

export const API_NAME = process.env.APP_NAME || process.env.REACT_APP_APP_NAME;

const CrudHandler = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const recordId = useSelector(state => state.crud.recordId);
  const mode = useSelector(state => state.crud.mode);
  const route = useSelector(state => state.crud.route);
  const dispatch = useDispatch();

  useEffect(() => {
        if (!route) return;

        if (mode === 'reload') {
            navigate(0);
            return;
        }

        if (mode === 'close-modal') {
            dispatch(removeActiveModal(route));
            return;
        }

        let targetPath = route;
        if (mode !== 'list') {
            targetPath = `${route}/${recordId}/${mode}`;
        }

        if (location.pathname === targetPath) {
            return;
        }

        navigate(targetPath);

    }, [navigate, location.pathname, route, mode, recordId, dispatch]);

    return null;
};

export default CrudHandler;